import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { Folder } from "lucide-react";
import { toast } from "sonner";

const SELECT_CLS =
  "bg-slate-50 dark:bg-slate-900/60 border border-slate-200 dark:border-slate-800 rounded-lg pl-8 pr-3 py-2 text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition appearance-none cursor-pointer max-w-[180px] truncate";

// value: folder id or "" (no folder). onChange(newValue)
export function FolderSelect({ value, onChange, allowNew = true, allOption = false }) {
  const [folders, setFolders] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/docs/folders");
      setFolders(data);
    } catch {
      /* silencioso */
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handle = async (e) => {
    const v = e.target.value;
    if (v === "__new__") {
      const name = window.prompt("Nombre de la nueva carpeta:");
      if (!name || !name.trim()) return;
      try {
        const { data } = await api.post("/docs/folders", { name: name.trim() });
        await load();
        onChange(data.id);
        toast.success("Carpeta creada");
      } catch (err) {
        toast.error(formatApiError(err.response?.data?.detail));
      }
      return;
    }
    onChange(v);
  };

  return (
    <div className="relative inline-flex items-center">
      <Folder size={15} className="absolute left-2.5 text-slate-400 pointer-events-none" />
      <select value={value ?? ""} onChange={handle} className={SELECT_CLS} data-testid="folder-select">
        {allOption && <option value="__all__">Todas las carpetas</option>}
        <option value="">Sin carpeta</option>
        {folders.map((f) => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
        {allowNew && <option value="__new__">➕ Crear carpeta…</option>}
      </select>
    </div>
  );
}
